import { ItemData } from 'core/models/Template'

export const ASKONA_CATALOG_TITLE_KEY = 'askonaCatalog' as const

export type AskonaSelectedItems = ItemData[]
